import { motion } from "framer-motion";
import { fadeUp, lineReveal, viewportOnce } from "../lib/motion";

export const Reveal = ({ children, i = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      variants={fadeUp}
      custom={i}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      className={className}
    >
      {children}
    </Tag>
  );
};

export const Lines = ({ lines, className = "", lineClassName = "", animateOnMount = false }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span className="mask-line" key={i}>
        <motion.span
          className={lineClassName}
          variants={lineReveal}
          custom={i}
          initial="hidden"
          {...(animateOnMount ? { animate: "visible" } : { whileInView: "visible", viewport: viewportOnce })}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export default Reveal;
